<section modalContainer background="true" rounded="true" class="hidden lg:block rounded-3xl" invisibleWhitespace="true">
    <main class="flex flex-col items-center justify-center gap-6 p-10 bg-white rounded-3xl w-fit min-w-[480px]">
        <div class="flex flex-col w-full gap-3">
            <button (click)="close()" class="flex justify-end w-full item-end">
                <app-icon name="material-symbols:close" class="text-zinc-500" />
            </button>
            <app-sign-in [modal]="true" />
        </div>
    </main>
</section>

<app-page-modal-container close="true" mainClass="bg-white" headerClass="bg-white" iconClass="text-zinc-400" class="lg:hidden">
    <section class="flex flex-col items-center justify-center gap-6 p-5 size-full">
        <app-sign-in [modal]="true" />
    </section>
</app-page-modal-container>
